import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox } from "@mui/material";

interface FormCheckboxProps {
  name: string;
  color?: "primary" | "secondary" | "default";
  size?: "small" | "medium";
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  name,
  color = "primary",
  size = "medium",
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field }) => (
        <div 
          onClick={() => field.onChange(!field.value)} 
          style={{ cursor: 'pointer', display: 'inline-block' }}
        >
          <Checkbox
            checked={field.value}
            color={color}
            size={size}
            inputProps={{ 'aria-label': name }}
          />
        </div>
      )}
    />
  );
};

export default FormCheckbox;